<template>
  <div>
    <div class="rmd_list_top">
      <i class="icon iconfont icon-dianzan t_blue"></i>你已成功推荐 {{dataInfo.Total}} 位好友完成购买
    </div>
    <div class="frd_list_cnt">
      <div class="frd_list_title">
        <div>推荐好友</div>
        <div>购买数量</div>
        <div>最近购买时间</div>
      </div>
      <div class='b_fff frd_list' v-for="(item, index) in dataList" :key="index">
        <div class='frd_list_left'>
          <img :src="item.HeadPortraitUrl === null ? require('@/assets/icon/defaultHead.png') : item.HeadPortraitUrl" />
          <div v-if="item.Nick">{{item.Nick | filtersText}}</div>
          <div v-else>{{item.LoginName | phoneEncode}}</div>
        </div>
        <div class="count">{{item.FinishCount}}</div>
        <div class='t_999'>{{item.LastFinishTime  | formatTime}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'BuyUserItem',
  data () {
    return {
    }
  },
  props: {
    dataList: {
      type: Array,
      require: true,
      default () {
        return []
      }
    },
    dataInfo: {
      type: Object,
      require: true,
      default () {
        return {}
      }
    }
  },
  filters: {
    formatTime (val) {
      return moment(val).format('YYYY-MM-DD')
    },
    phoneEncode (val) {
      if (!val) return '----'
      let star = val.substring(0, 3)
      let end = val.substring(val.length - 4, val.length)
      return star + '****' + end
    },
    filtersText (val) {
      if (!val) return '----'
      let len = 0
      for (let i = 0; i < val.length; i++) {
        let char = val.charAt(i)
        if (/\w/.test(char)) {
          len += 0.5
        } else {
          len += 1
        }
        if (len > 6) {
          val = val.slice(0, i) + '...'
          break
        }
      }
      return val
    }
  }
}
</script>

<style scoped>
  .rmd_list_top{
    display: flex;
    padding:0px 15px 0px 15px;
    height: 42px;
    line-height: 42px;
    background: #F2F2F2;
    box-sizing: border-box;
    font-size: 13px;
  }
  .rmd_list_top .icon{
    margin-right: 5px;
  }
  .frd_list_cnt{
    padding: 0 16px;
  }
  .frd_list_title{
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    color: #999;
    border-bottom: 1px solid #f6f6f6;
  }
  .frd_list_title > div{
    height: 40px;
    line-height: 40px;
    flex-grow: 1;
    text-align: center
  }
  .frd_list_title > div:first-child{
    flex-grow: 2;
    text-align: left;
    padding-left: 2%;
  }
  .frd_list_title > div:last-child{
    text-align: right;
  }
  .frd_list{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #f6f6f6;
  }
  .frd_list .count{
    flex-grow: 1;
  }
  .frd_list_left{
    display: flex;
    align-items: center;
    min-width: 53%;
  }
  .frd_list_left img{
    width: 45px;
    height: 45px;
    border-radius: 100%;
    margin: 0 15px 0 10px;
  }
</style>
